module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/congratulations/1911_birthday_cake-844ac79f03ac0542a47d6cc3bf5ad200.jpg";